const featureFlags = {
  STREAMING_GENERATION: process.env.REACT_APP_USE_STREAMING_GENERATION === 'true',
};

export default featureFlags;
